import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { RiferimentiPosizioneDTO } from "../dto/riferimento-posizioneDTO";
import { MapperTipoIstanzaFascicolo } from "./mapper-tipo-istanza-fascicolo";
import { RiferimentiPosizioneVO } from "../vo/riferimenti-posizioneVO";
import { MapperElementoVicino } from "./mapper-elemento-vicino";

@Injectable({
  providedIn: "root"
})
export class MapperRiferimentiPosizione
  implements MapperInterface<RiferimentiPosizioneDTO, RiferimentiPosizioneVO> {
  constructor(
    private mapperTipoFascicolo: MapperTipoIstanzaFascicolo,
    private mapperElementoVicino: MapperElementoVicino
  ) {}
  convertVoToDto(vo: RiferimentiPosizioneVO): RiferimentiPosizioneDTO {
    if (vo != null) {
      const dto = new RiferimentiPosizioneDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.idPadre = vo.idPadre;
      dto.oggettoPadre = vo.oggettoPadre;
      dto.tipoFascicoloPadre = this.mapperTipoFascicolo.convertVoToDto(
        vo.tipoFascicoloPadre
      );
      dto.elementoSuperiore = this.mapperElementoVicino.convertVoToDto(
        vo.elementoSuperiore
      );
      dto.elementoInferiore = this.mapperElementoVicino.convertVoToDto(
        vo.elementoInferiore
      );
      dto.posizione = vo.posizione;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: RiferimentiPosizioneDTO): RiferimentiPosizioneVO {
    if (dto != null) {
      const vo = new RiferimentiPosizioneVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.idPadre = dto.idPadre;
      vo.oggettoPadre = dto.oggettoPadre;
      vo.tipoFascicoloPadre = this.mapperTipoFascicolo.convertDtoToVo(
        dto.tipoFascicoloPadre
      );
      vo.elementoSuperiore = this.mapperElementoVicino.convertDtoToVo(
        dto.elementoSuperiore
      );
      vo.elementoInferiore = this.mapperElementoVicino.convertDtoToVo(
        dto.elementoInferiore
      );
      vo.posizione = dto.posizione;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: RiferimentiPosizioneVO[]
  ): RiferimentiPosizioneDTO[] {
    if (voList != null) {
      return voList.map(vo => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: RiferimentiPosizioneDTO[]
  ): RiferimentiPosizioneVO[] {
    if (dtoList != null) {
      return dtoList.map(dto => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
